export const messageTypes = [
  { id: 'message-type-sms', translateKey: 'modal_mass_message_type_sms', active: true },
  { id: 'message-type-push', translateKey: 'modal_mass_message_type_push', active: true },
  { id: 'message-type-email', translateKey: 'modal_mass_message_type_email', active: false },
];

export const smsTemplates = [
  { id: 'simple-twmplate-id', value: 'default-template', translateKey: 'default_sms_template_name' },
  { id: 'simple-twmplate-id-2', value: 'template-2', translateKey: 'default_sms_template_name-2' }
];

export const maxSmsMsgLength = 160;
export const maxTitleLength = 150;

export const validation = (values) => {
  const errors = {};
  //──── SMS ───────────────────────────────────────────────────────────────────────────────
  if (values.sms) {
    if (!values.smsMessage) { errors.smsMessage = 'required'; }
    if (values.smsMessage && values.smsMessage.length > maxSmsMsgLength) {
      errors.smsMessage = 'modal_mass_message_long_error';
    }
  }

  //──── Push ──────────────────────────────────────────────────────────────────────────────
  if (values.push) {
    if (values.pushTitle && values.pushTitle.length > maxTitleLength) {
      errors.pushTitle = 'modal_mass_message_long_error';
    }
    if (!values.pushMessage) { errors.pushMessage = 'required'; }
  }
  
  return errors;
};